import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { SButton, SIcon } from "../components";
import { useCommandKey, useKeyPress } from "../hooks";
import SDropdown from "../SDropdown/SDropdown";
const MoreIcon = /*#__PURE__*/ _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    children: [
        /*#__PURE__*/ _jsx("title", {
            children: "menu-dots"
        }),
        /*#__PURE__*/ _jsxs("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    fill: "currentColor",
                    cx: "12",
                    cy: "12",
                    r: "2"
                }),
                " ",
                /*#__PURE__*/ _jsx("circle", {
                    fill: "currentColor",
                    cx: "3",
                    cy: "12",
                    r: "2"
                }),
                " ",
                /*#__PURE__*/ _jsx("circle", {
                    fill: "currentColor",
                    cx: "21",
                    cy: "12",
                    r: "2"
                })
            ]
        })
    ]
});
export const PropertyButtonV2 = ({ label, value, isDynamic, asAccessory = false, onCommandClick, onOptionClick, menuActions, flipX = false })=>{
    const hasValue = !!value;
    const { isCommandPressed: command, setCommandPressed } = useCommandKey();
    const { isKeyPressed: option, setKeyPressed } = useKeyPress("Alt");
    let t = "unset";
    if (isDynamic) {
        t = "dynamic";
    } else {
        if (hasValue) {
            t = "literal";
        }
    }
    let classNames = "text-white bg-white/0 hover:bg-white/10";
    if (t === "dynamic") {
        classNames = " px-2  text-[#FF75FB] bg-[#FF75FB] bg-opacity-10 hover:bg-opacity-[0.15]";
    }
    if (t === "literal") {
        classNames = " px-2  text-brand-primary bg-brand-primary bg-opacity-10 hover:bg-opacity-[0.15]";
    }
    const button = useMemo(()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: `${asAccessory ? "" : "min-w-[80px]"} flex flex-row items-center ${flipX ? "justify-end" : "justify-start"} `,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `${asAccessory ? command || option ? "px-2" : "min-w-[30px]" : "!px-2 "} flex items-center justify-center h-[32px] group transition active:opacity-70 active:scale-[0.95] gap-1 transition cursor-pointer rounded-lg ${classNames}`,
                children: [
                    command ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"} group-hover:hidden font-normal`,
                                children: label
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"}  hidden  group-hover:inline-block pr-[3px] `,
                                children: /*#__PURE__*/ _jsx(SIcon, {
                                    size: 12,
                                    className: "opacity-70",
                                    type: "trash"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"} font-normal hidden group-hover:inline-block`,
                                children: "Clear"
                            })
                        ]
                    }) : option ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"} group-hover:hidden font-normal`,
                                children: label
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"}  hidden  group-hover:inline-block pr-[3px] `,
                                children: /*#__PURE__*/ _jsx(SIcon, {
                                    size: 12,
                                    className: "opacity-70",
                                    type: "bolt"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `${asAccessory ? "text-sm" : "!text-[13px]"} font-normal hidden group-hover:inline-block`,
                                children: "Edit"
                            })
                        ]
                    }) : null,
                    !command && !option && /*#__PURE__*/ _jsx("div", {
                        className: `${asAccessory ? "text-sm" : "!text-[13px]"} font-normal`,
                        children: label
                    })
                ]
            })
        });
    }, [
        asAccessory,
        classNames,
        command,
        option,
        label,
        onCommandClick
    ]);
    if (command) {
        return /*#__PURE__*/ _jsx("div", {
            className: "",
            onClick: command && onCommandClick ? ()=>{
                onCommandClick();
                setCommandPressed(false);
            } : undefined,
            children: button
        });
    }
    if (option) {
        return /*#__PURE__*/ _jsx("div", {
            className: "",
            onClick: option && onOptionClick ? ()=>{
                onOptionClick();
                setCommandPressed(false);
            } : undefined,
            children: button
        });
    }
    return /*#__PURE__*/ _jsx(SDropdown, {
        elements: menuActions || [],
        isUnstyledItems: true,
        position: "left",
        fixed: true,
        children: button
    });
};
export const MainPropsButton = ({ hasValue, isDynamic, onClick })=>{
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(SButton, {
            className: `!justify-end !-ml-1 !tracking-wide  ${isDynamic ? "text-[#FF75FB] bg-[#FF75FB] bg-opacity-10" : ""}`,
            variant: isDynamic || !hasValue ? "secondary" : "primary",
            size: "sm",
            onClick: onClick,
            children: MoreIcon
        })
    });
};
